import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class DataSupplierProductApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'data-supplier-product'
  }

}